import { Grid } from '@farewill/ui'
import { useFormikContext } from 'formik'

import InputFloating from 'components/form/input-floating'

import RadioGroup from '../components/radio-group'
import { OWNERSHIP_OPTIONS } from '../options'

type Props = {
  handleSave: (event: { name: string; value: string | number | null }) => void
  label?: string
  options?: { label: string; value: string }[]
  inline?: boolean
}

const OwnershipFields = ({
  handleSave,
  label = 'Ownership',
  options = OWNERSHIP_OPTIONS,
  inline = true,
}: Props) => {
  const { values, setFieldValue } = useFormikContext<Record<string, unknown>>()

  // a share only means something while the item is jointly owned
  const handleOwnershipSave: Props['handleSave'] = (event) => {
    handleSave(event)
    const share = values.deceasedShareOfJointOwnership
    if (event.value === 'joint' || share === null || share === '') return
    setFieldValue('deceasedShareOfJointOwnership', '')
    handleSave({ name: 'deceasedShareOfJointOwnership', value: null })
  }

  return (
    <>
      <Grid.Item span={12}>
        <RadioGroup
          label={label}
          name="ownership"
          options={options}
          handleSave={handleOwnershipSave}
          inline={inline}
        />
      </Grid.Item>
      {values.ownership === 'joint' && (
        <Grid.Item span={12}>
          <InputFloating
            name="deceasedShareOfJointOwnership"
            label="Share owned by the deceased (%)"
            handleSave={handleSave}
          />
        </Grid.Item>
      )}
    </>
  )
}

export default OwnershipFields
